import { Component } from '@angular/core';

import {AlertController, App, ModalController, NavController, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../providers/user-data';
import {Observable} from "rxjs/Observable";
import {TabsPage} from "../tabs-page/tabs-page";
import {TestPage} from "../test/test";
import {CivilityPage} from "../account/civility/civility";
import {CvAddForm} from "../account/cv/form/cvform";
import {AccountSettingsPage} from "../account/settings/settings";
import {AccountTabsPage} from "../account/tabs/tabs";
import {CvTabsPage} from "../account/cv/tabs/tabs";
import {MissionsTabsPage} from "../missions/missions-candidate/tabs/tabs";
import {MissionsListPage} from "../missions/missions-list/missions-list";
import {CvPage} from "../account/cv/cv";
import {DocumentsPage} from "../account/documents/documents";


@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomePage {
    username: string;
    userInfos: any;
    songs: AngularFireList<any>;
    displayName: string ="";
    displayName2: string ="";
    displayNote: any ="";
    sessionRef: any;
    userRef: any;

    available: boolean = true;
    available_at: any = false;
    jobs: any = [];

    location: any = "";
    phone: any = "";

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public afDatabase: AngularFireDatabase,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public app: App
    ) {
        //this.songs = afDatabase.list('/songs');
        //userData.setToken('nova4');

    }
    ionViewWillEnter() {
        //this.userData.checkLoggedIn(this.nav,'AccountPage');
        //this.getUserInfos();
    }
    ionViewDidLoad() {

        this.getUserInfos();
    }
    ionViewWillUnload() {

        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    ngAfterViewInit() {

    }
    switch() {
        this.nav.push('SwitchPage');
    }
    changeAvailability() {
        this.nav.push('AvailabilityPage');
    }
    updatePicture() {

    }

    // Present an alert with the current username populated
    // clicking OK will update the username and display it
    // clicking Cancel will close the alert and do nothing
    changeUsername() {
        let alert = this.alertCtrl.create({
            title: 'Change Username',
            buttons: [
                'Cancel'
            ]
        });
        alert.addInput({
            name: 'username',
            value: this.username,
            placeholder: 'username'
        });
        alert.addButton({
            text: 'Ok',
            handler: (data: any) => {
                this.userData.setUsername(data.username);
                //this.getUsername();
            }
        });

        alert.present();
    }

    getUserInfos() {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    that.userRef = that.userData.load().subscribe(user => {
                        let civility = that.userData.get('civility');
                        let address = that.userData.get('address');
                        let ranking = that.userData.get('ranking');
                        let availability = that.userData.get('availability');

                        if (civility && civility.prenom && civility.nom) {
                            that.displayName = civility.prenom+" "+civility.nom ;
                            that.displayName2 = civility.email;
                        }
                        else if (civility && civility.prenom) {
                            that.displayName = civility.prenom ;//+ ' ' + civility.nom
                            that.displayName2 = civility.email;
                        }
                        else if(civility && civility.email) {
                            that.displayName = civility.email.split('@')[0];
                            that.displayName2 = civility.email;
                        }
                        if(address && address.address)
                        {
                            that.location = address.zipcode + " " + address.city;
                        }
                        if(civility && civility.phone)
                        {
                            that.phone = civility.phone ;
                        }
                        if(ranking && ranking.note)
                        {
                            that.displayNote = ranking.note/5;
                        }
                        that.available = availability.available;
                    });
                }
            });
        }

    }
    changeAvailabilityEvent(event)
    {
        if(!event)
        {

        }
    }
    goMissions() {
        this.nav.push(MissionsListPage);
    }
    goActivity() {
        this.nav.push(MissionsTabsPage, {'tabIndex':0});
    }
    changeRanking() {
        if(/*true ||*/ !this.userData.get('ranking') || !this.userData.get('ranking').ok)
        {
            this.nav.push('SelfRankingPage');
        }
        else
        {
            this.nav.push('RankingPage');
        }
    }
    myInformations() {

        this.nav.push(AccountTabsPage, {'tabIndex':0});
        //this.app.getRootNav().push(AccountTabsPage, {'tabIndex':0});
        //this.app.getRootNav().push(AccountTabsPage, {'tabIndex':0});
        /*this.nav.setRoot('AccountTabsPage',{
            tabIndex: 0,
        });*/
        /*this.nav.push('AccountTabsPage',{
            tabIndex: 0,
        });*/
    }
    changePassword() {

    }
    changeIdentity() {
        this.nav.push('IdentityPage');
    }
    changeAddress() {
        this.nav.push('AddressPage');
    }
    changeCivility() {
        this.nav.push('CivilityPage');
    }
    changeCv() {
        this.nav.push(CvPage);
        //this.app.getRootNav().push(CvTabsPage, {'tabIndex':0});
        //this.nav.push('CvPage');
    }
    changeDocuments() {
        this.nav.push('DocumentsPage');
    }
    logout() {
        this.userData.logout();
        this.nav.setRoot('LoginPage');
    }

    support() {
        this.nav.push('SupportPage');
    }
    openContracts() {
        this.nav.push('ContractsPage');
    }
    openSalaries() {
        this.nav.push('SalariesPage');
    }
    openSettings(){
        let profileModal = this.modalCtrl.create(AccountSettingsPage);
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Paramètres enregistrés.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    documentsPage()
    {
        this.nav.push(DocumentsPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts